import { AlbumPage } from './../album/album';
import { album } from './../../models/album.model';
import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { AlbumService } from '../../service/album.service';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  constructor(public navCtrl: NavController, public albumService: AlbumService) {

  }

  open(item:album)
  {
    this.navCtrl.push(AlbumPage, {item: item});
  }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts